<svelte:options customElement={{
  tag: 'sns-icons',
  shadow: 'none',
  props: {
    items: { reflect: true, type: 'String' },
    circle: { reflect: true, type: 'Boolean' },
    footer: { reflect: true, type: 'Boolean' },
    sprite: { reflect: true, type: 'String' }
  }
}} />

<script>
  import SvgIcon from './SvgIcon.svelte';

  /**
   * SNSアイコン
   * パーツライブラリ準拠の mod-sns 構造
   * @prop {string} items - JSON '[{"name":"sns_x","href":"https://...","color":false}]'
   *   name: sns_facebook, sns_insta, sns_linkedin, sns_x, sns_youtube,
   *         sns_facebook-color, sns_line-color, sns_line-color-circle,
   *         sns_linkedin-color, sns_youtube-color
   *   color版アイコンはスプライト内の固定色版を使用
   *   sns_insta-color → PNG画像（/common/images/sns_insta.webp）
   * @prop {boolean} circle - 丸背景付き (_circle)
   * @prop {boolean} footer - フッター用白色 (_footer)
   * @prop {string} sprite - スプライトパス
   */
  export let items = '[]';
  export let circle = false;
  export let footer = false;
  export let sprite = '/common/svg/sprite.svg';

  let parsedItems = [];

  $: {
    try {
      parsedItems = typeof items === 'string' ? JSON.parse(items) : (Array.isArray(items) ? items : []);
    } catch (e) {
      console.warn('SnsIcons: Invalid items JSON', e);
      parsedItems = [];
    }
  }

  $: wrapClass = [
    'mod-sns',
    circle ? '_circle' : '',
    footer ? '_footer' : ''
  ].filter(Boolean).join(' ');

  function isInstaColor(name) {
    return name === 'sns_insta-color';
  }
</script>

<div class={wrapClass}>
  {#each parsedItems as item}
    <a href={item.href} target="_blank" rel="noopener noreferrer" aria-label={item.name}>
      {#if isInstaColor(item.name)}
        <img src="/common/images/sns_insta.webp" alt="Instagram" />
      {:else}
        <SvgIcon name={item.name} {sprite} />
      {/if}
    </a>
  {/each}
</div>
